import { render, staticRenderFns } from "./ServicoModal.vue?vue&type=template&id=75d00dcd&scoped=true"
import script from "./ServicoModal.vue?vue&type=script&lang=js"
export * from "./ServicoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d00dcd",
  null
  
)

export default component.exports